import $ from 'jquery';
// import 'owl.carousel';

class Blog {
  constructor() {
    this.carousel = $('.owl-carousel');

    if (!this.carousel.length) {
      return;
    }

    import('owl.carousel').then(() => {
      this.init();
    });
  }

  init() {
    this.carouselArgs = {};
    this.breakpoint = 768;
    this.linkToPage = $(window).width() <= this.breakpoint;

    this.setCarouselArgs();

    this.newsCarouselInit();
    this.coursesCarouselInit();
    this.testimonialsCarouselInit();
    this.imagesCarouselInit();
  }

  setCarouselArgs() {
    this.carouselArgs = {
      margin: 20,
      nav: true,
      navText: [
        '<svg class="c-icon c-icon--angle-left"><use xlink:href="#c-icon--angle-left"></use></svg>',
        '<svg class="c-icon c-icon--angle-right"><use xlink:href="#c-icon--angle-right"></use></svg>',
      ],
      rewind: true,
      // autoHeight: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 2,
        },
        768: {
          items: 3,
        },
      },
    };
  }

  newsCarouselInit() {
    this.newsCarousel = $('.js-news-carousel');

    if (this.newsCarousel.length) {
      this.newsItem = $('.js-blog-news-item');
      this.newsDetails = $('.js-blog-news-details');
      this.newsDetailsClose = $('.js-blog-news-details-close');
      this.newsOverlay = $('.js-blog-news-overlay');
      this.newsItemDetail = $('.js-blog-news-detail');

      this.newsCarousel.owlCarousel(this.carouselArgs);
    }
  }

  coursesCarouselInit() {
    this.coursesCarousel = $('.js-courses-carousel');

    if (this.coursesCarousel.length) {
      const args = $.extend(this.carouselArgs, {
        responsive: {
          0: {
            items: 1,
          },
          640: {
            items: 2,
          },
          1024: {
            items: 3,
          },
        },
      });
      this.coursesCarousel.owlCarousel(args);
    }
  }

  testimonialsCarouselInit() {
    this.testimonialsCarousel = $('.js-testimonials-carousel');

    if (this.testimonialsCarousel.length) {
      // this.testimonialsCarouselArgs = Object.assign({}, this.carouselArgs);
      this.testimonialsCarouselArgs = { ...this.carouselArgs };
      this.testimonialsCarouselArgs.responsive = {};
      this.testimonialsCarouselArgs.items = 1;
      this.testimonialsCarousel.owlCarousel(this.testimonialsCarouselArgs);
    }
  }

  imagesCarouselInit() {
    this.imagesCarousel = $('.js-images-carousel');

    if (this.imagesCarousel.length) {
      this.imagesCarouselArgs = { ...this.carouselArgs };
      const visibleItems = this.imagesCarousel.attr('data-items');

      this.imagesCarouselArgs.responsive = {
        0: {
          items: 2,
        },
        600: {
          items: visibleItems > 3 ? 3 : visibleItems,
        },
        768: {
          items: visibleItems > 4 ? 4 : visibleItems,
        },
        1024: {
          items: visibleItems,
        },
      };

      this.imagesCarousel.owlCarousel(this.imagesCarouselArgs);
    }
  }

  newsDetailsInit() {
    $(window).on('load', () => {
      this.toggleNewsDetails();
      this.closeNewsDetails();

      if (!this.linkToPage) {
        if ($(window).width() > this.breakpoint) {
          this.linkToPage = false;
        } else {
          this.linkToPage = true;
        }
      }
    });

    let debounce;
    $(window).on('resize', () => {
      clearTimeout(debounce);

      debounce = setTimeout(() => {
        if ($(window).width() > this.breakpoint) {
          this.linkToPage = false;
        } else {
          this.linkToPage = true;
        }
      }, 500);
    });
  }

  toggleNewsDetails() {
    this.newsItem.on('click', '.js-blog-news-item-link', e => {
      if (!this.linkToPage) {
        e.preventDefault();
      } else {
        return;
      }

      const link = $(e.currentTarget);
      const memberId = link.attr('data-blog-news-id');

      const newsItemDetails = $(`#news-item-details-${memberId}`);

      if (newsItemDetails.length) {
        this.newsItemDetail.hide();
        this.newsDetails.css('display', 'flex').css('opacity', 0);
        this.newsOverlay
          .show()
          .css('opacity', 0)
          .stop()
          .animate({ opacity: 1 }, 300, () => {
            newsItemDetails.find('.js-blog-news-detail').css('display', 'flex');
            this.newsDetails.stop().animate({ opacity: 1 }, 300);
          });
      }
    });
  }

  closeNewsDetails() {
    this.newsDetailsClose.on('click', () => {
      this.newsDetails.stop().animate({ opacity: 0 }, 300, () => {
        this.newsOverlay.stop().animate({ opacity: 0 }, 300);
        this.newsItemDetail.hide();
        this.newsDetails.hide();
        this.newsOverlay.hide();
      });
    });
  }
}

export default new Blog();



// WEBPACK FOOTER //
// ./src/scripts/modules/carousels.js